module.exports = __webpack_public_path__ + "images/dungeon-master-a339a8c1cec0bd1a326fc2aaf975f75f.png";